import { Button } from '@mui/material';

export interface CatalogUnavailableNoteProps {
  failed: boolean;
  failedMessage: string;
  emptyMessage: string;
  onRetry: () => void;
  testIdPrefix: string;
}

export const CatalogUnavailableNote = ({
  failed,
  failedMessage,
  emptyMessage,
  onRetry,
  testIdPrefix
}: CatalogUnavailableNoteProps) => (
  <p
    className="text-sm text-gray-500 mt-2"
    data-testid={`${testIdPrefix}-unavailable`}>
    {failed ? failedMessage : emptyMessage}
    {failed && (
      <Button
        size="small"
        onClick={onRetry}
        data-testid={`${testIdPrefix}-retry`}>
        Retry
      </Button>
    )}
  </p>
);
